<template>
    <div class="container page">
        <van-nav-bar :title="$t('acshop')" class="nav-bar" fixed>
            <template #left>
                <van-icon name="arrow-left" color="#fff" @click="back()" />
            </template>
            <template #right>
                <img src="../../assets/order-fill.png" alt="" style="width: 35px; height: 35px;" @click="toOrder">
            </template>
        </van-nav-bar>
        <div style="padding: 56px 0 0;">
            <van-search v-model="keys" show-action :placeholder="$t('qsrssgjc')" class="mallsearch">
                <template #action>
                    <div @click="onSearch">{{ $t('searchtxt') }}</div>
                </template>
            </van-search>
        </div>
        <div class="mallbox">
            <div v-for="v in list" :key="v.id" @click="toDetail(v)">
                <img :src="v.goods_pic" alt="">
                <div>
                    <div class="van-ellipsis">{{ v.goods_name }}</div>
                    <div>
                        <span>{{ $t('MAD') }} {{ v.goods_price }}</span>
                        <span>{{ $t('yishou') }} {{ v.sale_nums }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Mall",
    data() {
        return {
            keys: "",
            list: [],
        }
    },
    mounted() {
        this.initPage();
    },
    methods: {
        back() {
            return window.history.back();
        },
        toOrder() {
            this.$router.push({ path: '/MallOrder' });
        },
        toDetail(v) {
            this.$router.push({ path: '/MallDetail', query: { id: v.id } });
        },
        onSearch() {
            if (this.keys) {
                this.$httpNew({
                    method: 'get',
                    data: {
                        keys: this.keys,
                    },
                    url: 'search_aichao_goods'
                }).then(res => {
                    if (res.code == 0) {
                        this.list = (res.data || []).sort((a, b) => b.sale_nums - a.sale_nums);
                    } else {
                        this.list = [];
                    }
                })
            } else {
                this.initPage();
            }
        },
        initPage() {
            this.$httpNew({
                method: 'get',
                data: {},
                url: 'get_aichao_goodslist'
            }).then(res => {
                if (res.code == 0) {
                    this.list = (res.data || []).sort((a, b) => b.sale_nums - a.sale_nums);
                } else {
                    this.list = [];
                }
            })
        },
    }
}
</script>

<style lang='less' scoped>
.mallsearch {
    .van-cell {
        line-height: 50px;
    }
}

.mallbox {
    padding: 12px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #f2f2f2;

    >div {
        flex: 0 0 49%;
        margin-bottom: 10px;
        border-radius: 10px;
        background: #f2f2f5;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        overflow: hidden;
        background: #fff;

        >img {
            width: 100%;
            height: 230px;
            object-fit: cover;
        }

        >div {
            padding: 8px 5px;

            >div:nth-child(2) {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: 5px;
                font-size: 14px;

                >span:nth-child(1) {
                    color: #ee0a24;
                    font-weight: bold;
                }

                >span:nth-child(2) {
                    color: #646566;
                }
            }
        }
    }
}
</style>